import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-28c95ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-chip"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  fill: "#F3E7AB"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "sub-table-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-table-heading" }, "Рекламные площадки", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import { ref, computed, onMounted } from "vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import ArchiveConfirmDialog from "@/shared/dialogs/ArchiveConfirmDialog.vue";
import PlatformChip from "@/shared/chips/PlatformChip.vue";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";
import { useAuthStore } from "@/store/auth/login";

import {
  convertDateFromUTC,
  convertDateFromISOWithShortYear,
} from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import { useCampaignStore } from "@/store/campaigns/campaigns";
import { usePlatformsStore } from "@/store/dictionaries/platforms";
import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";
import { useRouter } from "vue-router";
import { rootGetters } from "@/main";
import { formatNumberWithFixed2 } from "@/services/utils/Strings";
import { calcCPC, calcCPM, calcCTR } from "@/services/campaigns/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'TraficPlanTable',
  props: {
    campaigns: {},
    isArchiveEnabled: { type: Boolean },
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const campaignsStore = useCampaignStore();
const campaignsDictionariesStore = useCampaignsDictionariesStore();
const platformsStore = usePlatformsStore();
const router = useRouter();
const authStore = useAuthStore();

let modifiedId = ref(0);
let modifiedEntity = ref("campaigns");
const confirmVisible = ref({
  delete: false,
  archive: false,
  history: false,
});
const blockedButton = ref({
  delete: false,
  archive: false,
});
const menu = ref();
const menuTraficPlan = ref();
const expandedRows = ref({});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      router.push({ name: "traficPlan", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Архивировать",
    icon: "pi pi-inbox",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      confirmVisible.value.archive = true;
    },
  },
  {
    label: "Разархивировать",
    icon: "pi pi-inbox",
    checkDenied: false,
    archive: "archive",
    command: () => {
      campaignsStore.unArchiveCampaign(modifiedId.value).then(() => {
        emits("updateTable");
      });
    },
  },
  {
    label: "Дублировать",
    icon: "pi pi-copy",
    checkDenied: false,
    archive: "no_archive",
    command: () => {
      campaignsStore.duplicateCampaignId = modifiedId.value;
      router.push({ name: "traficPlanCreate" });
    },
  },
  {
    label: "Удалить",
    checkDenied: false,
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const traficPlanItems = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
]);

onMounted(() => {
  platformsStore.getPlatforms();
});

const filteredItems = computed(() => {
  const itemsDenied = items.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
  return itemsDenied.filter((item) =>
    props.isArchiveEnabled
      ? ["both", "archive"].includes(item.archive)
      : ["both", "no_archive"].includes(item.archive)
  );
});

const filteredTraficPlanItems = computed(() => {
  return traficPlanItems.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
});

const toggle = (segmentId: number, event: any) => {
  modifiedId.value = segmentId;
  modifiedEntity.value = "campaigns";
  menu.value.toggle(event);
};

const toggleTraficPlan = (segmentId: number, event: any) => {
  modifiedId.value = segmentId;
  modifiedEntity.value = "campaign_traffic_plans";
  menuTraficPlan.value.toggle(event);
};

const deleteCampaign = () => {
  blockedButton.value.delete = true;
  campaignsStore
    .deleteCampaign(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButton.value.delete = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

const archiveCampaign = () => {
  blockedButton.value.archive = true;
  campaignsStore.archiveCampaign(modifiedId.value).finally(() => {
    emits("updateTable");
    blockedButton.value.archive = false;
    confirmVisible.value.archive = false;
  });
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.campaigns,
      expandedRows: expandedRows.value,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((expandedRows).value = $event)),
      class: _normalizeClass([[
      _ctx.campaigns && _ctx.campaigns.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(DataTable), {
            value: slotProps.data.traffic_plans,
            class: "sub-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "platform",
                header: "Рекламная площадка",
                style: {"min-width":"175px"}
              }, {
                body: _withCtx((slotPropsPlan) => [
                  _createVNode(PlatformChip, {
                    "icon-class": slotPropsPlan.data.platform_slug
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(platformsStore).platformsMap[slotPropsPlan.data.platform_slug]
                    .name), 1)
                    ]),
                    _: 2
                  }, 1032, ["icon-class"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_impressions",
                header: "Показы план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  (slotPropsPlan.data.plan_impressions)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(formatNumberWithFixed2)(slotPropsPlan.data.plan_impressions)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_click",
                header: "Клики план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  (slotPropsPlan.data.plan_click)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(formatNumberWithFixed2)(slotPropsPlan.data.plan_click)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_cost",
                header: "Бюджет план (без НДС), ₽"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  (slotPropsPlan.data.plan_cost)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(formatNumberWithFixed2)(slotPropsPlan.data.plan_cost)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_reach",
                header: "Охват план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  (slotPropsPlan.data.plan_reach)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(formatNumberWithFixed2)(slotPropsPlan.data.plan_reach)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_ctr",
                header: "CTR план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(formatNumberWithFixed2)(
                    _unref(calcCTR)(
                      slotPropsPlan.data.plan_click,
                      slotPropsPlan.data.plan_impressions
                    )
                  )), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_cpc",
                header: "CPC план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(formatNumberWithFixed2)(
                    _unref(calcCPC)(
                      slotPropsPlan.data.plan_click,
                      slotPropsPlan.data.plan_cost
                    )
                  )), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "plan_cpm",
                header: "CPM план"
              }, {
                body: _withCtx((slotPropsPlan) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(formatNumberWithFixed2)(
                    _unref(calcCPM)(
                      slotPropsPlan.data.plan_impressions,
                      slotPropsPlan.data.plan_cost
                    )
                  )), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                frozen: "",
                alignFrozen: "right"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", {
                    onClick: (event) => toggleTraficPlan(slotProps.data.id, event),
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_menu",
                    class: "button-menu"
                  }, _hoisted_18, 8, _hoisted_16)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          expander: "",
          style: {"min-width":"52px","max-width":"52px"}
        }),
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название РК",
          sortable: "",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'traficPlan', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "period",
          header: "Период",
          style: {"max-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromISOWithShortYear)(slotProps.data.start_date)) + " - " + _toDisplayString(_unref(convertDateFromISOWithShortYear)(slotProps.data.end_date)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "brand",
          header: "Бренд"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.brand)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.data.brand.brand_name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser__lname",
          header: "Пользователь",
          sortable: "",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.cuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "state",
          header: "Статус",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(slotProps.data.state),
              xmlns: "http://www.w3.org/2000/svg",
              width: "8",
              height: "8",
              viewBox: "0 0 8 8",
              fill: "none"
            }, _hoisted_6, 2)),
            _createTextVNode(" " + _toDisplayString(_unref(campaignsDictionariesStore).statesMap.get(slotProps.data.state)?.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_9, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_unref(Menu), {
      ref_key: "menuTraficPlan",
      ref: menuTraficPlan,
      id: "overlay_menu",
      model: filteredTraficPlanItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "кампанию",
      visible: confirmVisible.value.delete,
      blocked: blockedButton.value.delete,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value.delete = false)),
      onDelete: deleteCampaign
    }, null, 8, ["visible", "blocked"]),
    _createVNode(ArchiveConfirmDialog, {
      "archived-name": "рекламную кампанию",
      visible: confirmVisible.value.archive,
      blocked: blockedButton.value.archive,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (confirmVisible.value.archive = false)),
      onArchive: archiveCampaign
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UsersHistoryDialog, {
      entity: _unref(modifiedEntity),
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["entity", "object_id", "visible"])
  ], 64))
}
}

})